module.exports = __webpack_public_path__ + "img/logo3.c95af590.svg";